function PrintFormWithNotes(caption, previewUri) {
    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 || navigator.userAgent.toLowerCase().indexOf('edge') > -1) {
        printPreviewFF(previewUri);
    }
    else {
        printPreview(previewUri);
    }
}

var _printIframe;
printPreview = function (url) {
    var iframe = this._printIframe;
    if (!this._printIframe) {
        iframe = this._printIframe = document.createElement('iframe');
        document.body.appendChild(iframe);

        iframe.style.display = 'none';
        iframe.onload = function() {
            setTimeout(function() 
            {
	            iframe.focus();
	            iframe.contentWindow.print();
            }, 1);
        };
    }

    iframe.src = url;
};

printPreviewFF = function (url) 
{
    _printIframe = window.open(url, "PrintPreview");
    _printIframe.document.title = "Print Preview";
};